import Helpers from "../../resources/js/utils/helpers";

export default class News extends Helpers {
  constructor() {
    super();
    Helpers.registerHandler(
      "click",
      this.ajaxLoadMore.bind(this),
      ".news-load-more",
    );
  }

  async ajaxLoadMore(el) {
    if (el.classList.contains("is-loading")) return;

    const currentOffset = parseInt(el.getAttribute("data-offset"));

    const section = el.closest(".news-section");
    const container = section.querySelector(".news-load-more-container");

    el.classList.add("is-loading");
    el.innerText = "Cargando...";

    try {
      const result = await this.ajaxFetchPost({
        action: "ajax_load_news",
        offset: currentOffset,
      });

      if (result.success) {
        container?.insertAdjacentHTML("beforeend", result.data.html);

        el.setAttribute("data-offset", result.data.new_offset);

        if (!result.data.has_more) {
          el.remove();
        }

      } else {
        container.insertAdjacentHTML(
          "afterend",
          `<div class="sk-error-message"><p>No se pudieron cargar las publicaciones. Por favor, intenta de nuevo.</p></div>`,
        );

        console.error(result.data?.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("AJAX Error:", error);
    } finally {
      el.classList.remove("is-loading");
      el.innerText = "Ver más";
    }
  }
}

new News();
